<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="medicoListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prestadores: {{ dados ? dados.search : 'Carregando...' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3" v-if="medicos">
                            <az-input 
                                type="button-group" 
                                :optionsList="[
                                    { id: 'T', search: 'Todos' },
                                    { id: 'S', search: 'Selecionados' },
                                ]"
                                v-model="tipo_exibicao" />

                            <az-input icon="fas fa-filter" 
                                type="select" 
                                optionsMode="esp-ativas"
                                optionsName="esp-ativas"
                                :optionsReload="true"
                                placeholder="Filtro por Especialidade..."
                                v-model="especialidade" />
                            
                            <az-input
                                icon="fa fa-search" 
                                placeholder="Pesquisar..."
                                v-model="search" />
                        </div>

                        <table class="table table-sm border-0 table-responsive">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <az-empty-state v-if="!lista || !lista.length" msg="Nenhum médico identificado." />

                        <div v-else>

                            <template v-if="tipo_exibicao == 'T'">
                                <az-input
                                    type="checkbox-group"
                                    label="TODOS"
                                    v-model="todos"
                                    @click="trocando = true;" />

                                <div v-for="(medico, idx) in lista" :key="idx">
                                    <az-input 
                                        type="checkbox-group"
                                        :label="medico.search"
                                        v-model="medico.selecionado" />
                                </div>
                            </template>

                            <template v-else>
                                <div v-for="(medico, idx) in lista" :key="idx">
                                    <label class="form form-control mb-1">
                                        {{ medico.search }}
                                    </label>
                                </div>
                            </template>
                        </div>
                        
                        <pre v-if="1 == 0" class="alert alert-info">{{ medicos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <h5 class="mb-0">
                            <span class="badge badge-secondary mr-2" v-if="medicos">
                                {{ selecionados }}
                            </span>
                        </h5>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit :color="remover ? 'danger' : 'primary'" @click="atualizar()">{{ para_selecionar ? 'Selecionar' : ( ( id && Array.isArray(id) ) ? ( remover ? 'Remover' : 'Incluir' ) : 'Atualizar' ) }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from './forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzEmptyState from '../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null,
            medicos: [], 
            model: null,
            id: null, 
            search: "", 
            especialidade: "", 
            tipo_exibicao: "T",
            trocando: false, 
            remover: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState
    },

    computed: { 
        todos: { 
            get() {
                return this.lista.findIndex(item => !item.selecionado) < 0;
            },
            set(value) {
                if ( this.trocando ) { 
                    this.lista.forEach(element => {
                        element.selecionado = value;
                    });

                    this.trocando = false;
                }
            }
        },

        lista_classes: function () { 
            return _.uniq(
                this.lista.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },

        selecionados: function () { 
            return this.lista.filter(item => item.selecionado).length;
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.medicos && this.medicos.length 
                ? this.medicos.filter(item => this.tipo_exibicao == 'T' || item.selecionado)
                    .filter (item => { 
                        return ( !this.search || reg.test(JSON.stringify(item)) );
                    })
                    .filter(item => { 
                            return !this.especialidade || item.medico_especialidade.find(me => me.id_especialidade == this.especialidade.id_especialidade);
                        }
                    )
                : [];
        },
    },

    props: [
        'agenda_compartilhada',
        'para_selecionar'
    ],

    methods: { 
        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        atualizar () { 
            if ( this.para_selecionar ) { 
                this.$emit('selecionar', this.lista.filter(item => item.selecionado));
                return;
            }

            this.$util.atualizar(this, { 
                service: 'medicos',
                func: 'store_lista',
                dados: { 
                    id: this.id,
                    model: this.model, 
                    items: this.lista,
                    remover: this.remover, 
                },
                modal: 'medicoListaModal',
                callback: () => { 
                    this.$emit('refresh');
                } 
            });
        },

        abrir(model, id, remover = false) { 
            this.remover = remover;
            this.model = model;
            this.id = id;

            this.load();

            $('#medicoListaModal').modal('show');
        },
        load() { 

            this.dados = [];
            this.medicos = [];
            this.search = "";
            this.especialidade = "";

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'medicos.index',
                        id: "medicos",
                        parms: {
                            ativos: true, 
                            sem_agenda_compartilhada: this.agenda_compartilhada ? false : true,
                        }
                    }
                ]
            };

            if ( this.id && !Array.isArray(this.id) ) { 
                query.q.push({
                    name: 'medicos.lista',
                    id: "lista",
                    parms: {
                        id: this.id,
                        model: this.model,
                    }
                });
            }

            return this.axios.post("/aql", query)
                .then(res => {
                    if (res.data.lista && res.data.lista.status == 200) {
                        this.dados = res.data.lista.data;
                    }

                    if (res.data.medicos.status == 200) {
                        this.medicos = res.data.medicos.data.map(item => { 
                            let selec;

                            if ( this.id && !Array.isArray(this.id) ) {
                                selec = this.dados.medico_lista.find(el => el.id_medico == item.id_pessoa);
                            } else { 
                                selec = false;
                            }

                            item.selecionado = selec ? true : false;
                            item.item_lista = selec;

                            return item;
                        });

                        this.tipo_exibicao = this.selecionados ? 'S' : 'T';
                    }
                })
                .finally(() => { 
                    this.$store.commit("loading", false);
                });

        }
    }
}
</script>